import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ClinicDashboard from './pages/ClinicDashboard';
import './clinics.css';
const Clinics = () => {
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-hospital"></i> Clinics
                </h1>
                <Link to="/clinics/new" className="btn btn-sm btn-outline-primary">
                    <i className="bi bi-plus"></i> Start Onboarding
                </Link>
            </div>

            <Card className="clinic-list-card shadow-sm border-0 rounded-0">
                <Card.Body className="p-3">
                    <ClinicDashboard
                        searchPanelOpen={searchPanelOpen}
                        onSearchPanelToggle={() => setSearchPanelOpen((open) => !open)}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default Clinics;
